import { IAddNotePayload } from "models/notes";
import { useCentralApi, useCurrentUser } from "hooks/shared";

const makeWorkItemNotesUrl = (id: number | string | undefined, draft?: boolean) => draft 
    ? `/api/v3/drafts/workitems/notes/${id}`
    : `/api/v3/workitems/${id}/notes`;

const useAddWorkItemNote = (workItemId: number | string | undefined, onRefresh: () => void, draft?: boolean) => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const handleAddWorkItemNote = async (payload: IAddNotePayload) => {
        const urlRoot = makeWorkItemNotesUrl(workItemId, draft);
        const resp = await fetcher(urlRoot, {
            method: 'POST',
            body: JSON.stringify(payload)
        });

        onRefresh();
    };

    return (payload: IAddNotePayload) => {
        handleAddWorkItemNote(payload)
    };
};

export default useAddWorkItemNote;